import { Component, OnInit, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { SecurityService } from '../../security/security.service';
import { MatDialog } from '@angular/material/dialog';
import { DialogWithCloseButtonComponent } from '../../utils/dialog-with-close-button/dialog-with-close-button.component';
import { Addr } from '../model/addr.model';



@Component({
  selector: 'app-address',
  templateUrl: './address.component.html',
  styleUrls: ['./address.component.scss'],
  standalone: false
})

export class AddressComponent implements OnInit, OnChanges {
  @Input() addressInput: Addr;
  addressLine1: string = '';
  addressLine2: string = '';
  city: string = '';
  stateOrProvinceId: number;
  countryId: number = 231;
  zipOrPostalCode: string = '';
  address: Addr;


  //@Output is used to intereact with parent component. 
  //It is part of @angular/core. To emit event to parent Output and EventEmitter is needed in import line
  @Output() addressChangeEvent = new EventEmitter<Addr>();

  countries: any;
  states: any;
  popMsg = {
    'title': '',
    'message': ''
  }


  constructor(private services: SecurityService, public dialog: MatDialog) { }

  ngOnInit(): void {

    this.services.getCountries().subscribe(
      res => {
        this.countries = res;// as Countries[];
        //console.log(this.countries);
      },
      err => {
        console.log(err)
      }
    );
    this.address = this.addressInput;
    //console.log("Address-Comp:Country Id passed is " + this.address.countryId);  
    this.getStatesByCountry(this.address.countryId);
    //console.log("Address-Comp:Address: " + JSON.stringify(this.address));
    //console.log("Address-Comp:States: " + this.states);

  }

  ngOnChanges(): void {
    this.address = this.addressInput;
    console.log("Address comonent on change");
  }

  public onCountryChanged(event: any) {
    let coountryNameSelected = event.source.selected.viewValue
    this.getStatesByCountry(this.address.countryId);
    console.log("Country Selected: " + coountryNameSelected);
  }

  submitAddress() {
    if (!this.isFormCompleted()) return;
    this.addressChangeEvent.emit(this.address);
  }

  isFormCompleted(): boolean {
    if (this.address.addressLine1 == null || this.address.addressLine1 === '') {
      this.popMsg.title = 'Incomplete address';
      this.popMsg.message = 'Please enter the first line of address';

      this.openDialog(this.popMsg);
      return false;
    }

    if (this.address.city == null || this.address.city === '') {
      this.popMsg.title = 'Incomplete address';
      this.popMsg.message = 'Please enter the city';

      this.openDialog(this.popMsg);
      return false;
    }

    if (this.address.stateOrProvinceId == null) {
      this.popMsg.title = 'Incomplete address';
      this.popMsg.message = 'Please select the state';

      this.openDialog(this.popMsg);
      return false;
    }

    if (this.address.zipOrPostalCode == null || this.address.zipOrPostalCode === '') {
      this.popMsg.title = 'Incomplete address';
      this.popMsg.message = 'Please enter the zip or postal code';

      this.openDialog(this.popMsg);
      return false;
    }

    if (this.address.countryId == null) {
      this.popMsg.title = 'Incomplete address';
      this.popMsg.message = 'Please select the country';

      this.openDialog(this.popMsg);
      return false;
    }
    return true;
  }

  getStatesByCountry(countryId) {
    this.services.getStates(countryId).subscribe(
      res => {
        this.states = res;
        //console.log("Address-Conp:" + JSON.stringify(this.states));
      },
      err => {
        console.log(err)
      }
    );
  }

  openDialog(popupMessage) {
    this.dialog.open(DialogWithCloseButtonComponent, { data: popupMessage });
  }



}
